import { render, staticRenderFns } from "./CollapseSidebar.vue?vue&type=template&id=4f51021a"
import script from "./CollapseSidebar.vue?vue&type=script&lang=js"
export * from "./CollapseSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports